var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('GenericTable',{attrs:{"title":"Versiones / Releases","icon":"mdi-package-variant","items":_vm.releases,"headers":_vm.headers,"loading":_vm.loading},on:{"refresh":function($event){return _vm.$emit('refresh')}}})}
var staticRenderFns = []

export { render, staticRenderFns }